import React, {useEffect, useState} from 'react';
import { connect } from 'react-redux';
import queryString from 'query-string';
import GatewayEditor from './EditorPages/GatewayEditor';
import GatewayResults from './ResultsPages/GatewayResults';

function Gateways({
    urlParams
}) {
    const [queryParams,setQueryParams] = useState(urlParams);
    useEffect(() => {
        setQueryParams(queryString.parse(urlParams));
    },[urlParams])
    return (
        queryParams && queryParams['id'] ?
            <GatewayEditor id={queryParams['id']} /> :
            <GatewayResults />
    );
}

const mapStateToProps = (state) => ({
    urlParams: state.router.location.search,
});

export default connect(mapStateToProps, null)(Gateways);